import { errorResponse, failResponse } from "config/config";
import { dateFormat, reverseString } from "config/utils";
import { useCourse } from "context/context";
import React, { useCallback, useEffect, useState } from "react";
import { FaDownload, FaEye } from "react-icons/fa";
import { Link, useParams, useNavigate } from "react-router-dom";
import { getSignedUrl } from "services/master";
import { postalContent } from "services/postal";

const NewPostalFileListing = () => {
    const { id } = useParams();
    const [fileListing, setFileListing] = useState([]);
    const [mainUrl, setMainUrl] = useState("");
    const [loading, setLoading] = useState(false);

    const [submitLoading, setSubmitLoading] = useState(false);
    const safeReplaceAll = (str, search, replace) => str ? str.replaceAll(search, replace) : "";
    const prevCourseId = React.useRef(null);
    const { course } = useCourse();

    const navigate = useNavigate();

    const getPostalFiles = useCallback(async (courseId, folderId) => {
        let folderpath = folderId;

        if (folderId.endsWith("//")) {
            folderpath = folderId.slice(0, -1); // remove only one slash
        }
        try {
            setLoading(true);
            const res = await postalContent({
                courseId,
                folderName: folderpath,
            });
            if (res.code === 200) {
                const folders = res.data.subfolders.flat().map((data) => ({ ...data, type: "Folder" }));
                const files = res.data.files.map((data) => ({ ...data, type: "File" }));
                setFileListing([...folders, ...files]);
                setMainUrl(res.data.url);

                setMainUrl(res.data.url);
                setLoading(false);
            } else {
                failResponse(res);
                setLoading(false);
            }
        } catch (err) {
            errorResponse(err);
            setLoading(false);
        }
    }, []);

    const breadcrumbNavigator = (ind) => {
        const mainUrl = "/dashboard/new-postal-folder-listing/";

        // If ind === -1, go to root postal folder list
        if (ind === -1) {
            navigate(mainUrl);
            return;
        }

        const parts = safeReplaceAll(id, "-", "/").split("/").filter(Boolean);
        const folderPath = parts.slice(0, ind + 1).join("/");
        const encodedPath = safeReplaceAll(folderPath, "/", "-");
        const fullPath = `${mainUrl}${encodedPath}/`;
        navigate(fullPath);
    };





    const notesDownloadHandler = async (note) => {
        setSubmitLoading(true);
        window.open(await getSignedUrl({ pdfUrl: note }));
        setSubmitLoading(false);
    };



    useEffect(() => {
        if (!course?.isPostal) {
            navigate("/dashboard/home");
            return;
        }

        if (course?.courseId) {
            if (prevCourseId.current && prevCourseId.current !== course.courseId) {
                // course changed → go to root folder listing
                navigate("/dashboard/new-postal-folder-listing/");
            } else {
                // same course → just load the current folder
                const folderPath = safeReplaceAll(id, "-", "/");
                const normalizedPath = folderPath ? `${folderPath}/` : "";
                getPostalFiles(course.courseId, normalizedPath);
            }

            // update previous courseId
            prevCourseId.current = course.courseId;
        }
    }, [course, id, getPostalFiles, navigate]);



    return (
        <>
            <section className="courser_report spacing upload_answer_sheet">
                <div className="container">
                    {/* Breadcrumb */}
                    <div className="breadcrumb" style={{ marginBottom: "10px" }}>
                        <div className="container">
                            <ul>
                                <li key="root" >
                                    <span
                                        style={{ fontWeight: "700", fontSize: "15px" }}
                                        className="link"
                                        onClick={() => breadcrumbNavigator(-1)} // navigate to top postal listing
                                    >
                                        Postal Course
                                    </span>
                                </li>
                                {id &&
                                    safeReplaceAll(id, "-", "/")
                                        .split("/")
                                        .filter(Boolean)
                                        .map((data, i) => (
                                            <li key={i}>
                                                <span className="link" onClick={() => breadcrumbNavigator(i, data)} style={{ fontWeight: "700", fontSize: "15px" }}>
                                                    {data} {/* show actual folder name */}
                                                </span>
                                            </li>
                                        ))}
                            </ul>

                        </div>
                    </div>
                    <div className="_box">
                        <h4>{(course?.courseName) ? course.courseName : "Postal Course Docs"}</h4>
                        <div className="table_wrap">
                            <table className="table table-striped table-bordered table-hover">
                                <thead>
                                    <tr>
                                        <th>SN.</th>
                                        <th>Name</th>
                                        <th>Type</th>
                                        <th>Add on</th>
                                        <th>Size</th>
                                        <th>Download/View</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* loading */}
                                    {loading && (
                                        <tr>
                                            <td colSpan={7} className="text-center">
                                                Loading ...
                                            </td>
                                        </tr>
                                    )}

                                    {/* main data row */}
                                    {!loading &&
                                        fileListing?.length > 0 &&
                                        fileListing.map(
                                            ({ fileName, createdAt, size, type, fileURL }, i) => {
                                                return (
                                                    <tr key={i}>
                                                        <td>{i + 1}.</td>
                                                        <td className="text-start">
                                                            {type === "Folder" && (
                                                                <Link
                                                                    to={`/dashboard/new-postal-folder-listing/${safeReplaceAll(fileName, "/", "-")}`}
                                                                >
                                                                    <a style={{ fontWeight: "500" }}>{fileName.split("/").filter(Boolean).slice(-1)[0]}</a>
                                                                </Link>

                                                            )}
                                                            {type === "File" && (
                                                                <>
                                                                    {reverseString(
                                                                        reverseString(fileName).split("/")[0]
                                                                    )}
                                                                </>
                                                            )}
                                                        </td>
                                                        <td>{type}</td>
                                                        <td>{dateFormat(createdAt)}</td>
                                                        <td>{size}</td>

                                                        <td>
                                                            {type === "File" && (
                                                                <button
                                                                    className="dashboard_button"
                                                                    onClick={() =>
                                                                        notesDownloadHandler(mainUrl + fileName)
                                                                    }
                                                                    disabled={submitLoading}
                                                                >
                                                                    <FaDownload /> Download
                                                                </button>
                                                            )}

                                                            {type === "Folder" && (
                                                                <Link
                                                                    className="dashboard_button"
                                                                    style={{ width: "60%" }}
                                                                    to={`/dashboard/new-postal-folder-listing/${safeReplaceAll(fileName, "/", "-")}`}
                                                                >
                                                                    <FaEye /> View
                                                                </Link>

                                                            )}
                                                        </td>
                                                    </tr>
                                                );
                                            }
                                        )}

                                    {/* not found row */}
                                    {!loading && fileListing?.length <= 0 && (
                                        <tr>
                                            <td colSpan={7} className="text-center">
                                                No records available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default NewPostalFileListing;
